import API from './api';
import { Urls } from './urls';


export const NotificationMessageService = {
    get: async function () {
        return API.get(Urls.ApiNotificationMessage)
    },
}
